import React from "react";
import { Backdrop, CircularProgress, styled, Box } from "@mui/material";

export const StyledBackDrop = styled(Backdrop)({
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  zIndex: 100,
});

export const ProgressBar = () => {
  return (
    <>
      <StyledBackDrop open={true}>
        <CircularProgress thickness={2} size="80px" />
      </StyledBackDrop>
    </>
  );
};
